import { createContext, useContext } from "react";
import type { EntityAvatarGroupEntity } from "@components/avatar/EntityAvatarGroup";

/**
 * Cross-workspace entity lookup for History rows that are rendered outside a
 * single workspace scope (e.g. organization-scoped Chart of Accounts template
 * Activity). Keyed by entity id.
 *
 * When this context is absent, History cells fall back to the workspace-scoped
 * `useEntitiesById()` lookup, keeping the standard workspace Activity behavior
 * unchanged. This map is lookup metadata only and never dictates which rows or
 * entity ids a row contains — that remains backend-authoritative.
 */
export type HistoryEntityIconMap = ReadonlyMap<number, EntityAvatarGroupEntity>;

export const historyEntityMapContext =
    createContext<HistoryEntityIconMap | null>(null);

export function useHistoryEntityMap(): HistoryEntityIconMap | null {
    return useContext(historyEntityMapContext);
}
